export const TAB_STYLES = {
  height: 50,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px', // Adds space between the icon and the label
  minHeight: 'auto',
}
